module.exports = __webpack_public_path__ + "static/media/landing-tab-provider-search-m.25e2ff37.svg";